module.exports = __webpack_public_path__ + "img/店中店申請表.0ac85d77.png";